// src/components/AddressForm.js
import { useEffect, useRef, useState } from "react";
import api from "../api.js";
import { useT } from "../i18n/LanguageContext.js";
import { useNavigate, useLocation, useParams } from "react-router-dom";


export default function AddressForm({ onNext }) {
  const t = useT();
  const [form, setForm] = useState({
    name:"", email:"", phone:"",
    address:"", city:"", province:"", postalCode:""
  });
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");
  const alertRef = useRef(null);
  const { productType: ptParam } = useParams(); // /address/:productType

  useEffect(()=>{ if (err && alertRef.current) alertRef.current.focus(); }, [err]);
  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setSubmitting(true);
    try {
      const res = await api.post("/address", form);
      onNext({ addressId: res.data.id, address: form });
    } catch {
      setErr(t("alerts.saveAddressFail"));
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} aria-describedby={err ? "addr-error" : undefined} noValidate>
      <h2 style={{ marginTop: 0 }}>{t("step1Title")}</h2>

      {err && (
        <div id="addr-error" ref={alertRef} role="alert" className="alert" tabIndex="-1">
          {err}
        </div>
      )}

      <div className="grid-2">
        <div className="field">
          <label htmlFor="name">{t("field.name")}<span aria-hidden="true">{t("req")}</span></label>
          <input id="name" required value={form.name} onChange={onChange("name")} autoComplete="name" />
        </div>
        <div className="field">
          <label htmlFor="email">{t("field.email")}<span aria-hidden="true">{t("req")}</span></label>
          <input id="email" type="email" required value={form.email} onChange={onChange("email")} autoComplete="email" />
        </div>
        <div className="field">
          <label htmlFor="phone">{t("field.phone")}<span aria-hidden="true">{t("req")}</span></label>
          <input id="phone" type="tel" required value={form.phone} onChange={onChange("phone")} autoComplete="tel" />
        </div>
        <div className="field">
          <label htmlFor="postalCode">{t("field.postal")}<span aria-hidden="true">{t("req")}</span></label>
          <input id="postalCode" required value={form.postalCode} onChange={onChange("postalCode")} autoComplete="postal-code" />
        </div>
        <div className="field" style={{ gridColumn: "1 / -1" }}>
          <label htmlFor="address">{t("field.street")}<span aria-hidden="true">{t("req")}</span></label>
          <input id="address" required value={form.address} onChange={onChange("address")} autoComplete="street-address" />
        </div>
        <div className="field">
          <label htmlFor="city">{t("field.city")}<span aria-hidden="true">{t("req")}</span></label>
          <input id="city" required value={form.city} onChange={onChange("city")} autoComplete="address-level2" />
        </div>
        <div className="field">
          <label htmlFor="province">{t("field.province")}<span aria-hidden="true">{t("req")}</span></label>
          <input id="province" required value={form.province} onChange={onChange("province")} autoComplete="address-level1" />
        </div>
      </div>

      <div className="status" role="status" aria-live="polite">
        {submitting ? t("status.savingAddress") : ""}
      </div>

      <div className="btn-row">
        <button className="btn primary" type="submit" disabled={submitting} aria-disabled={submitting}>
          {submitting ? t("status.savingAddress") : t("btn.next")}
        </button>
      </div>
    </form>
  );
}
